import { render, staticRenderFns } from "./AttachementList.vue?vue&type=template&id=369644bc&scoped=true"
import script from "./AttachementList.vue?vue&type=script&lang=js"
export * from "./AttachementList.vue?vue&type=script&lang=js"
import style0 from "./AttachementList.vue?vue&type=style&index=0&id=369644bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369644bc",
  null
  
)

export default component.exports